import httpClientService from '@/services/httpClientService';
export default {
	getLoginMethods: () =>
		httpClientService.Get('/UserContextModule/api/Login/method'),

	getClients: () => httpClientService.Get('/UserContextModule/api/Clients'),
	getSelectedClient: () =>
		httpClientService.Get('/UserContextModule/api/Clients/Selected'),

	getProjects: () => httpClientService.Get('/UserContextModule/api/Projects'),
	getSelectedProject: () =>
		httpClientService.Get('/UserContextModule/api/Projects/Selected'),
	getSelectedProjectSettings: () =>
		httpClientService.Get(
			'/UserContextModule/api/Projects/Selected/Settings'
		),
	getPermissions: () =>
		httpClientService.Get('/UserContextModule/api/User/GetUserPermissions'),

	downloadFile: (id) =>
		httpClientService.Get(
			`/UserContextModule/api/File/DownloadFile?id=${id}`,
			{
				responseType: 'blob',
			}
		),

	updateSelectedProject: (item) =>
		httpClientService.Post('/UserContextModule/api/Projects', item),
	updateSelectedClient: (item) =>
		httpClientService.Post('/UserContextModule/api/Clients', item),

	changePassword: (item) =>
		httpClientService.Post(
			'/UserContextModule/api/User/ChangePassword',
			item
		),

	getNotifications: (skip = 0, take = 25) =>
		httpClientService.Get(
			`/UserContextModule/api/Notifications?skip=${skip}&take=${take}`
		),
	getUnreadNotificationsCount: () =>
		httpClientService.Get(
			'/UserContextModule/api/Notifications/unread-count'
		),
	deleteNotification: (id) =>
		httpClientService.Delete(`/UserContextModule/api/Notifications/${id}`),
	markNotificationAsRead: (id) =>
		httpClientService.Put(
			`/UserContextModule/api/Notifications/${id}/mark-read`
		),
	markAllNotificationsAsRead: () =>
		httpClientService.Put(
			'/UserContextModule/api/Notifications/mark-all-read'
		),
	markSelectedNotificationsAsRead: (notificationIds) =>
		httpClientService.Put(
			'/UserContextModule/api/Notifications/mark-selected-read',
			notificationIds
		),
	deleteSelectedNotifications: (notificationIds) =>
		httpClientService.Delete(
			'/UserContextModule/api/Notifications/delete-selected',
			notificationIds
		),
};
